import cx from 'classnames';
import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext, {
  useFacetData
} from '~/context/common/FacetDataContext';
import { colorHexValues } from './constants';
import Checkbox from '../Checkbox';

function UnspecifiedSwatch() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z"
        fill="#F6F7F9"
        stroke="#BECBDA"
      />
      <path d="M20.4863 3.51123L3.51577 20.4818" stroke="#BECBDA" />
    </svg>
  );
}

type LabelProps = {
  color: string;
  displayName: string;
  isOther: boolean;
};

const Label = ({ color, displayName, isOther }: LabelProps) => (
  <div className="flex justify-between">
    <span>{displayName}</span>
    {isOther ? (
      <UnspecifiedSwatch />
    ) : (
      <div
        className={cx('h-2xl w-2xl rounded-full', {
          'border border-black': color === 'White'
        })}
        style={{ background: colorHexValues[color] }}
      />
    )}
  </div>
);

type OwnProps = {
  filterKey: 'colors' | 'interiorColors';
};

export default function ColorSwatches({ filterKey }: OwnProps) {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { showInventoryCounts } = useContext(FacetDataContext);
  const facetData = useFacetData();

  const sortedBuckets = facetData[filterKey]?.buckets
    ?.filter(bucket => bucket.count > 0)
    ?.toSorted((a, b) => {
      if (a.key === 'Other') return 1;
      if (b.key === 'Other') return -1;

      return 0;
    });

  return (
    <div className="grid gap-lg">
      {sortedBuckets?.map(({ count, displayName, key }) => {
        const isOther = key === 'Other';
        const color = isOther
          ? 'Unspecified'
          : displayName.replace(/(interior|exterior)/i, '').trim();

        return (
          <Checkbox
            checked={appliedFilters[filterKey]?.includes(key)}
            className="grid grid-cols-[auto_1fr]"
            facet={filterKey}
            filter={key}
            id={`${filterKey} - ${displayName}`}
            key={`${filterKey} - ${displayName}`}
            label={
              <Label
                color={color}
                displayName={
                  showInventoryCounts
                    ? `${color} (${count.toLocaleString()})`
                    : color
                }
                isOther={isOther}
              />
            }
            onChange={() => {
              updateListFilter({
                value: key,
                filterKey
              });
            }}
          />
        );
      })}
    </div>
  );
}
